import React, { Component } from 'react'
import mapboxgl from 'mapbox-gl';
import { isEqual } from 'lodash'
import styles from './styles.scss'

mapboxgl.accessToken = 'pk.eyJ1IjoibG9pYzI5NCIsImEiOiJjaW54a3IwcWYxNzhodWFtMzc4eGs2Y2V4In0.IhCIftgKJJBi8gTnI4_8ng';

export default class Map extends Component {

  constructor() {
    super()
    this.id = "map" + Math.round(Math.random() * 100000)
    this.map = {};
  }

  componentDidMount() {

			const { points, hasDetails, basePoint } = this.props

      if (!mapboxgl.supported()) {
          console.error("Ce navigateur ne supporte pas Mapbox GL : ", navigator.userAgent);
      } else {

        this.map = new mapboxgl.Map({
          container: this.id,
          center: this.props.center,
          zoom: 13,
          style: 'mapbox://styles/loic294/cit6lvoss000v2xo4fhduaqvs'
        });

        this.map.on('load', () => {

            for (var i = 0; i < points.length; i++) {
              const point = points[i];

                this.map.addSource('single-point-' + i  , {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": points.map(({ geometry, details }) => {
                          return {
                            "type": "Feature", 
														"geometry": geometry,
														"properties": {
															"state": details.state,
															"description": `
																<div class="${styles.popup}">
																	<h1>${details.user.first_name} ${details.user.last_name}</h1>
																	<small><i>${details.user.email} • ${details.user.phone_number}</i></small>
																	<div class="flex f-align-center f-wrap ${styles.subjects}">
																		${details.tutor_subject_levels.map(({ level, subject}) => `<div class="tag small">${subject.name} • <i>${level.name}</i></div>`).join('')}	
																	</div>
																	<a href="/users/tutor/${details.user._id}" target="_blank">
																		<button class="small">Voir le profil</button>
																	</a>
																</div>
															`
														}
                        }})
                    }
                });

								if (this.map.getLayer("points")) {
									this.map.removeLayer("points");
								}
                this.map.addLayer({
                    "id": "points",
                    "source": 'single-point-' + i,
                    "type": "circle",
                    "paint": {
											"circle-color": {
													property: 'state',
													type: 'categorical',
													stops: [
															['validated', '#8BC34A'],
															['completed', '#FFC837'],
															['refused', '#e53935'],
															['in-progress', '#cc8924'],
															['selected', '#345995'],
													]
											},
											"circle-radius": {
													'base': 12,
													'stops': [[10, 9], [22, 360]]
											},
											"circle-opacity" : 0.95
									}
								});
						
						} // End map loaded

						console.log('BASE POINT', basePoint)
						if (basePoint) {
							this.map.addSource('home', {
								"type": "geojson",
								"data": {
										"type": "FeatureCollection",
										"features": [{
											"type": "Feature",
											"geometry": basePoint,
										}]				
								}
							})

							if (this.map.getLayer("home")) {
								this.map.removeLayer("home");
							}
							this.map.addLayer({
									"id": "home",
									"source": 'home',
									"type": "circle",
									"paint": {
										"circle-color": '#222',
										"circle-radius": {
												'base': 9,
												'stops': [[10, 9], [22, 360]]
										},
										"circle-opacity" : 1
								}
							});
						}
						
						if (hasDetails) {
							this.map.on('click', 'points', (e) => {
								if (!e.features.length) return

								var coordinates = e.features[0].geometry.coordinates.slice();
								var description = e.features[0].properties.description;
								
								while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
										coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
								}

								var popup = new mapboxgl.Popup()
										.setLngLat(coordinates)
										.setHTML(description)
										.addTo(this.map);

								console.log('ADD POPUP')
							});
			
							this.map.on('mousemove', (e) => {
									var features = this.map.queryRenderedFeatures(e.point, { layers: ['points'] });
									this.map.getCanvas().style.cursor = (features.length) ? 'pointer' : '';
							});
						}


				});
			

      }


  }

  componentDidUpdate(prevProps) {
    if(!isEqual(prevProps.points, this.props.points)) {

      for (var i = 0; i < this.props.points.length; i++) {
        const point = this.props.points[i];

        this.map.getSource('single-point-' + i).setData({
            "type": "FeatureCollection",
            "features": this.props.points.map(({ geometry }) =>{
              return {
                "type": "Feature",
                "geometry": geometry
            }})
				});
				
				if (this.props.basePoint) {
					this.map.getSource('home').setData({
						"type": "geojson",
						"data": {
								"type": "FeatureCollection",
								"features": {
									"type": "Feature",
									"geometry": this.props.basePoint,
								}				
						}
					})
				}

      }

    }
  }

  render() {
    return <div className={styles.map} id={this.id}></div>
  }

}



// WEBPACK FOOTER //
// ./src/components/Map/index.js